

import { Component, Vue } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import InternalTicketsRepositoryInterface, { SettingType } from '@/services/Internal-Tickets/interfaces';
import Setting from '@/views/pages/internal-tickets/Setting.vue';
import ComponentEntity, { PriorityEntity } from '@/services/Internal-Tickets/interfaces/interfaces';
import { StatusEntity } from '@/services/Internal-Tickets/interfaces/status.entity';
import TicketSettingsEditDialog from '@/views/pages/internal-tickets/TicketSettingsEditDialog.vue';
import TicketSettingsDeleteDialog from '@/views/pages/internal-tickets/TicketSettingsDeleteDialog.vue';
import SettingEntity from '@/services/Internal-Tickets/interfaces/setting.entity';

@Component({
  computed: {
    SettingType() {
      return SettingType;
    },
  },
  components: { TicketSettingsDeleteDialog, TicketSettingsEditDialog, Setting },
  inject: ['internalTicketsRepository'],
})
export default class SettingsList extends Vue {
  private loading: boolean = true;
  private editDialogVisible: boolean = false;
  private deleteDialogVisible: boolean = false;

  private setting: SettingEntity;
  private settingType: SettingType | null = null;

  private statuses: StatusEntity[] = [];
  private priorities: PriorityEntity[] = [];
  public components: ComponentEntity[] = [];
  private readonly internalTicketsRepository: InternalTicketsRepositoryInterface;

  private headers: DataTableHeader[] = [
    { text: 'Id', value: 'id' },
    { text: 'Name', value: 'name' },
    { text: 'color', value: 'color' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  private async mounted(): Promise<void> {
    await this.initialize();
    this.loading = false;
  }

  private async initialize(): Promise<void> {
    this.statuses = await this.getStatuses();
    this.priorities = await this.getPriorities();
    this.components = await this.getComponents();
  }

  private async getStatuses(): Promise<StatusEntity[]> {
    try {
      return this.internalTicketsRepository.getStatuses();
    } catch (e) {
      this.$errorDialog.show('Failed to retrieve statuses: ' + e.message);
      return [];
    }
  }

  private async getPriorities(): Promise<StatusEntity[]> {
    try {
      return this.internalTicketsRepository.getPriorities();
    } catch (e) {
      this.$errorDialog.show('Failed to retrieve priorities: ' + e.message);
      return [];
    }
  }

  private async getComponents(): Promise<ComponentEntity[]> {
    try {
      return this.internalTicketsRepository.getComponents();
    } catch (e) {
      this.$errorDialog.show('Failed to retrieve components: ' + e.message);
      return [];
    }
  }

  private get prioritySetting(): PriorityEntity[] {
    return this.priorities;
  }

  private get statusSetting(): StatusEntity[] {
    return this.statuses;
  }

  private get componentSetting(): ComponentEntity[] {
    return this.components;
  }

  public async openEditDialog(argument: SettingEntity, type: SettingType) {
    this.settingType = type
    this.setting = argument
    this.editDialogVisible = true;
  }

  public async openDeleteDialog(argument: SettingEntity, type: SettingType) {
    this.settingType = type;
    this.setting = argument;
    this.deleteDialogVisible = true;
  }

  public async cancelEditDialog() {
    this.editDialogVisible = false;
  }

  public cancelDeleteDialog() {
    this.deleteDialogVisible = false;
  }

  public async refresh(type: SettingType) {
    this.$successDialog.show('Setting has been updated')
    if (type === SettingType.PRIORITY) {
      this.priorities = await this.getPriorities();
    }

    if (type === SettingType.COMPONENT) {
      this.components = await this.getComponents();
    }

    if (type === SettingType.STATUS) {
      this.statuses = await this.getStatuses()
    }
    this.deleteDialogVisible = false;
    this.editDialogVisible = false;
  }


}
